//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "SectionEventAnotherEventsSlider",
  components: {
    EmptyEntityCardsSlider: () => import("@/components/common/EmptyEntityCardsSlider"),
    Section: () => import("@/components/common/Section/index"),
    EventCard: () => import("@/components/common/EventCard/index"),
    SliderWithBullets: () => import("@/components/common/SliderWithBullets/index"),
    Scroller: () => import("@/components/common/Scroller")
  },
  computed: {
    ...mapGetters({
      events: "events/events",
      pending: "events/pending",
      eventId: "event/id"
    }),
    gap() {
      return this.$mediaSwitch({hd: 32, sm: 8, defaultValue: 24});
    },
    columns() {
      return this.$mediaSwitch({md: 2, sm: 1, defaultValue: 3});
    },
    anotherEvents() {
      return this?.events?.filter(item => item.id !== this.eventId);
    },
    show() {
      return this.pending || this.anotherEvents.length > 0;
    }
  },
  mounted() {
    if (this.eventId) {
      this.$store.dispatch("events/fetch", {
        clear: true,
        params: {
          resolution: "micro",
          started_at: this.$moment().format("YYYY-MM-DD")
        }
      });
    }
  }
};
